(function($, window, undefined) {
    var returned = [];

    /*function addImagePreview(file, target) {
        if (file && target) {
            reader = new FileReader();

            reader.onload = function(element) {
                var img = $('<img/>', {
                    id: 'dynamic',
                    width: 250,
                    height: 200
                });

                img.attr('src', element.target.result);

                target.html(img);
            }

            reader.readAsDataURL(file);
        }
    }*/

    function getFormattedDate(elementId) {
        var format = new Date([
            $('select[name="year_item_' + elementId + '"]').val(),
            $('select[name="month_item_' + elementId + '"]').val(),
            $('select[name="day_item_' + elementId + '"]').val()
        ].join('-'));
        var requestDate = format.toISOString().split('T')[0];
        var formatDate = requestDate.split('-');
        var finalDate = formatDate[2] + '/' + formatDate[1] + '/' + formatDate[0];

        return finalDate;
    }

    function isValidProductReceivedDate(selectedDate) {
        var currentDate = new Date();
        var maxDate = new Date([
            currentDate.getFullYear(),
            ('0' + (currentDate.getMonth() + 1)).slice(-2),
            ('0' + currentDate.getDate()).slice(-2)
        ].join('-'));

        return maxDate > selectedDate;
    }

    function isValidDate(elementId) {
        var year = $('select[name="year_item_' + elementId + '"]').val();
        var month = $('select[name="month_item_' + elementId + '"]').val();
        var day = $('select[name="day_item_' + elementId + '"]').val()

        var isValid = false;

        if (year && month && day) {
            var monthsWith31 = ['01', '03', '05', '07', '08', '10', '12'];

            if (monthsWith31.indexOf(month) !== -1) {
                isValid = parseInt(day) <= 31;
            } else {
                if (month !== '02') {
                    isValid = parseInt(day) <= 30;
                } else {
                    var isLeapYear = year % 400 === 0 || (year % 4 === 0 && year % 100 !== 0);

                    isValid = isLeapYear ? parseInt(day) <= 29 : parseInt(day) <= 28;
                }
            }

            if (isValid) {
                isValid = isValidProductReceivedDate(new Date([year, month, day].join('-')));
            }
        }

        return isValid;
    }

    function sendTicket(returnProduct) {
        var name = window.order.data.email.substr(0, window.order.data.email.indexOf('@'));

        var body =  [
            'name: ' + name,
            'type: ' + returnProduct.type,
            'orderId: ' + window.order.data.orderName,
            'lineItemId: ' + returnProduct.product.id,
            'productName: ' + returnProduct.product.name,
            'productSKU: ' + returnProduct.product.sku,
            'productDate: ' + returnProduct.productDate,
            'productQualityRate: ' + returnProduct.productQualityRate,
            'reason: ' + returnProduct.reason,
            'describeReason: ' + returnProduct.describeReason,
            'photoUrl: ' + returnProduct.photoUrl,
            'price: ' + returnProduct.product.price,
            'domain: ' + window.liquidVars.adminDomain,
            'domainUrl: ' + window.location.href
        ];

        /*var discountPercentage = window.order.data.total_discounts ?
            Math.round(window.order.data.total_discounts * 100 / window.order.data.total_line_items_price) : 0
        ;

        if (discountPercentage) {
            var discountCodes = window.order.data.discount_codes.map(function(discount) {
                return discount.code;
            });

            body.push('discountPercentage: ' + discountPercentage + '%');
            body.push('discountCodes: ' + discountCodes.join(', '));
        }*/

      	var discountAllocationsVarName = 'discount_allocations';
      	if (returnProduct.product[discountAllocationsVarName] && returnProduct.product[discountAllocationsVarName].length) {
      		var discountCodes = window.order.data.discount_codes.map(function(discount) {
                return discount.code;
            });

          	body.push('discountPercentage: ' + Math.round(returnProduct.product[discountAllocationsVarName][0].amount * 100 / returnProduct.product.price) + '%');
          	body.push('discountCodes: ' + discountCodes.join(', '));
        }

        return new Promise(function(resolve, reject) {
            var response = $.ajax({
                url: 'https://gateway.ecommerce-wh.com/support/tickets',
                type: 'POST',
                cache: false,
                crossDomain: true,
                data: JSON.stringify({
                    ticket: {
                        recipient: window.liquidVars.contactEmail, //set this variable into html with shop.email liquid var (this can't be defined here)
                        requester: {
                            name: name,
                            email: window.order.data.email
                        },
                        subject: returnProduct.type + ' OrderId #' + window.order.data.orderName,
                        comment: {
                            body: body.join('\n')
                        },
                        custom_fields: [{ id: '44966709', value: domainTag }]
                    }
                }),
                contentType: 'application/json',
            });

            resolve(response);
        }).catch(function(err) {
            throw {
                err: returnProduct.product.name + ' no pudo ser devuelto, por favor inténtelo de nuevo más tarde',
                id: returnProduct.product.id
            };
        });
    }

    function sendWithoutPhoto(returnProduct) {
        return sendTicket(returnProduct)
            .then(function(data) {
                returned.push(returnProduct.product.id)

                return data;
            })
            .catch(function(err) {
                return err;
            })
        ;
    }

    function uploadPhoto(returnProduct) {
        var fd = new FormData();
            fd.append('file', returnProduct.photo);
            fd.append('fileName', window.order.data.id + '-' + returnProduct.product.id);

        return new Promise(function(resolve, reject) {
            var response = $.ajax({
                url: 'https://gateway.ecommerce-wh.com/files/upload/photo',
                type: 'POST',
                cache: false,
                crossDomain: true,
                processData: false,
                contentType: false,
                data: fd,
            });

            resolve(response);
        }).then(function(data) {
            returnProduct.photoUrl = 'https://d1eupmcfk4wy81.cloudfront.net/' + data.filePath;

            return sendTicket(returnProduct)
                .then(function(data) {
                    returned.push(returnProduct.product.id)

                    return data;
                })
                .catch(function(err) {
                    return err;
                })
            ;
        }).catch(function(err) {
            return {
                err: returnProduct.product.name + ' no pudo ser devuelto, por favor elija otra foto.',
                id: returnProduct.product.id
            };
        });
    }

    function sendForm() {
        var returnLength = window.order.returnProducts.length;
        var hasErrors;

        $('.error').hide();

        window.order.returnProducts.forEach(function(element, index) {
            var elementId = element.product.id + '_' + index;

            var reasonVal = $('select[name="reason_item_' + elementId + '"] option:selected').val();
            var fileVal = $('input[name="file_item_' + elementId + '"]')[0].files[0];
            var extraVal = $('textarea[name="extra_item_' + elementId + '"]').val();
            var rateVal = $('input[name="rate_item_' + elementId + '"]:checked').val();

            if (!reasonVal) {
                $('#reason_error_' + elementId).fadeIn();

                hasErrors = true;
            } else {
                element.reason = reasonVal;
            }

            if (
                !fileVal ||
                fileVal.size > 10485760
            ) {
                if (reasonVal === 'Defective Product Received') {
                    $('#photo_error_' + elementId).fadeIn();

                    hasErrors = true;
                }

                delete element.photo;
            } else {
                element.photo = fileVal;
            }

            if (!extraVal) {
                $('#extra_error_' + elementId).fadeIn();

                hasErrors = true;
            } else {
                element.describeReason = extraVal;
            }

            if (
                !isValidDate(elementId)
            ) {
                $('#date_error_' + elementId).fadeIn();

                hasErrors = true;
            } else {
                element.productDate = getFormattedDate(elementId);
            }

            if (!rateVal) {
                $('#rate_error_' + elementId).fadeIn();

                hasErrors = true;
            } else {
                element.productQualityRate = rateVal;
            }
        });

        if (!hasErrors) {
            $('body').addClass('modal-open');

            var promises = [];
            window.order.returnProducts.map(function(element) {
                promises.push(element.photo ? uploadPhoto(element) : sendWithoutPhoto(element));
            });

            Promise.all(promises)
                .then(function(data) {
                    var promiseCounter;
                    var promiseLength = data.length;

                    for (promiseCounter = 0; promiseCounter < promiseLength; promiseCounter++) {
                        if (data && data[promiseCounter] && data[promiseCounter].err) {
                            $('#return_item_error_' + data[promiseCounter].id + ' .errormessage').html(data[promiseCounter].err);
                            $('#return_item_error_' + data[promiseCounter].id).show();
                            $('#return_item_' + data[promiseCounter].id).addClass('error')
                        }
                    }
                })
                .catch(function(err) {
                    console.log(err)
                })
                .then(function() {
                    var returnedCounter;
                    var returnedLength = returned.length;

                    for (returnedCounter = 0; returnedCounter < returnedLength; returnedCounter++) {
                        $('#return_item_' + returned[returnedCounter] + '_' + returnedCounter).remove();

                        $('#productContainer li input:checked')
                            .filter(function(el) {
                                return $(this).val() !== 'None'; }
                            )
                            .closest('li')
                            .remove()
                        ;

                        window.order.returnProducts.splice(
                            window.order.returnProducts.indexOf(
                                window.order.returnProducts.find(function(returnProduct) {
                                    return returnProduct.product.id === returned[returnedCounter]
                                })
                            ),
                            1
                        );
                    }

                    if (!$('#returnContainer li').length) {
                        var dearName = '';
                        if (window.order.data.customer) {
                            var customer = window.order.data.customer;

                            dearName = customer.first_name ?
                                (customer.first_name ? customer.first_name : '') + (customer.last_name ? ' ' + customer.last_name : '') : customer.email
                            ;
                        }

                        $('#returnContainer').html(
                            '<li class="list-group-item">' +
                                '<div class="row">' +
                                    '<div class="col-xs-12">' +
                                        '<h4 style="font-size:18px; font-weight: bold; margin-bottom: 25px;">Su solicitud ha sido correctamente envíada.</h4>' +
                                        (dearName ? '<p style="font-size: 15px;">Estimado <b>' + dearName + '</b></p>' : '') +
                                        '<p style="font-size: 15px;">Comenzaremos a revisar su caso en las próximas 24 a 48 horas hábiles y contactaremos con usted con la resolución e instrucciones para completar el cambio o la decolución.</p>' +
                                        '<p style="font-size: 15px;"Por favor, tenga paciencia. Puede llevar algún tiempo, estamos trabajando para darle la mejor solución posible.</p>' +
                                        '<p style="font-size: 15px;">Gracias.</p>' +
                                    '</div>' +
                                '</div>' +
                            '</li>'
                        );
                    }

                    if (!$('#productContainer li').length) {
                        $('#productContainer').html(
                            '<li class="list-group-item">' +
                                '<div class="row">' +
                                    '<div class="col-xs-12">' +
                                        '<h3 class="text-center">Parece que no hay más productos en su pedido</h3>' +
                                        '<p class="text-center" style="margin-top: 40px; margin-bottom: 30px;"></p>' +
                                    '</div>' +
                                '</div>' +
                            '</li>'
                        );
                    }

                    $('body').removeClass('modal-open');
                })
            ;
        } else {
            $('#return-error').fadeIn();
        }
    }

    $(document).ready(function() {
        $('#continue3').off().on('click', function(e) {
            $('#return-error').hide();
            $('.returnReasonError, .returnPhotoError, .returnDescribeReasonError, .returnDateError, .returnItemError, .returnRateError').hide();
            $('#returnContainer li').removeClass('error')

            sendForm();
        });
    });
})(jQuery, window);